import * as z from "zod/v4";

export const getTopDenialReasons = {
  name: "getTopDenialReasons" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    reasons: z.array(z.object({ reason: z.string(), count: z.number() })),
  }),
};
